import React from 'react';
import { motion } from 'framer-motion';
import {
  EyeIcon,
  HeartIcon,
  ChatBubbleLeftIcon,
  UserPlusIcon,
  ArrowTrendingUpIcon, ArrowTrendingDownIcon,
  MagnifyingGlassIcon
} from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';
import { Card, CardHeader, CardTitle, CardContent } from '../ui/Card';

interface AnalyticsData {
  profile_views: { current: number; change: number };
  collaboration_requests: { current: number; change: number };
  opportunity_applications: { current: number; change: number };
  new_followers: { current: number; change: number };
  search_appearances?: { current: number; change: number };
}

interface AnalyticsWidgetProps {
  data: AnalyticsData;
  userType: 'creator' | 'model' | 'hirer';
}

const AnalyticsWidget: React.FC<AnalyticsWidgetProps> = ({ data, userType }) => {
    const navigate = useNavigate()
  const metrics = [
    // {
    //   title: 'Profile Views',
    //   value: data.profile_views.current,
    //   change: data.profile_views.change,
    //   icon: EyeIcon,
    // },
    {
      title: 'Search Appearances',
      value: data.search_appearances?.current || 0,
      change: data.search_appearances?.change || 0,
      icon: MagnifyingGlassIcon,
    },
    {
      title: 'Collab Requests',
      value: data.collaboration_requests.current,
      change: data.collaboration_requests.change,
      icon: HeartIcon,
    },
    {
      title: 'Applications',
      value: data.opportunity_applications.current,
      change: data.opportunity_applications.change,
      icon: ChatBubbleLeftIcon,
    },
    {
      title: 'New Followers',
      value: data.new_followers.current,
      change: data.new_followers.change,
      icon: UserPlusIcon,
    }
  ];
  

  return (
    <Card className="border-none shadow-sm">
      <CardHeader className="flex flex-row items-center justify-between pb-4">
        <CardTitle className="text-lg font-bold">Performance</CardTitle>
        <button 
            onClick={() => navigate('/dashboard/performance')}
            className="text-sm text-gray-500 hover:text-black font-medium transition-colors dark:text-gray-400 dark:hover:text-white"
            >
            View Details →
        </button>
      </CardHeader>

      <CardContent>
        <div className="grid grid-cols-2 gap-4">
          {metrics.map((metric, index) => (
            <motion.div
              key={metric.title}
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: index * 0.1 }}
              className="p-3 md:p-4 bg-gray-50 rounded-2xl border border-gray-100 hover:border-gray-200 transition-colors dark:bg-gray-800 dark:border-gray-700 dark:hover:border-gray-600"
            >
              <div className="flex items-center justify-between mb-3">
                <div className="p-2 rounded-xl bg-white shadow-sm dark:bg-gray-700 dark:shadow-none">
                  <metric.icon className="h-4 w-4 text-black dark:text-white" />
                </div>
                
                <div className={`flex items-center space-x-1 text-xs font-medium ${
                  metric.change >= 0 ? 'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400'
                }`}>
                  {metric.change >= 0 ? (
                    <ArrowTrendingUpIcon className="h-3 w-3" />
                  ) : (
                    <ArrowTrendingDownIcon className="h-3 w-3" />
                  )}
                  <span>{metric.change >= 0 ? '+' : ''}{metric.change}%</span>
                </div>
              </div>
              
              <div className="text-xl md:text-2xl font-bold text-gray-900 mb-1 dark:text-white">
                {metric.value.toLocaleString()}
              </div>
              <div className="text-[10px] md:text-xs text-gray-500 font-medium uppercase tracking-wide dark:text-gray-400">{metric.title}</div>
            </motion.div>
          ))}
        </div>
        

      </CardContent>
    </Card>
  );
};

export default AnalyticsWidget;
